import { DatatableCell, Skeleton } from '@monksflow/monks-ui';

import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

export const ConnectedAppsSkeletonRow = () => (
  <TableSkeletonRow testId="connected-apps-skeleton-row">
    <DatatableCell>
      <div className="flex items-center gap-2">
        <Skeleton className="size-8 rounded-full" />
        <Skeleton className="h-4 w-32" />
      </div>
    </DatatableCell>

    <DatatableCell>
      <div className="flex gap-xs">
        <Skeleton className="h-5 w-32 rounded-full" />
        <Skeleton className="h-5 w-24 rounded-full" />
      </div>
    </DatatableCell>

    <DatatableCell>
      <Skeleton className="h-4 w-20" />
    </DatatableCell>

    <TableSkeletonActionsCell />
  </TableSkeletonRow>
);
